const session = {
	namespaced: true,
	state: {
		jwt : (localStorage.getItem('jwt')) ? localStorage.getItem('jwt') : '',
		isLoggedIn : (localStorage.getItem('jwt')) ? true : false,
		user: (localStorage.getItem('user')) ? localStorage.getItem('user') : '{}',
		userDb: {},
		workspace: (localStorage.getItem('workspace')) ? localStorage.getItem('workspace') : '{}',
		brand: {},
		whiteLabel: true,
		preferences: {
			notifications: (localStorage.getItem('preferencesNotification') == 'false') ? false : true,
			inboxView2: (localStorage.getItem('preferencesInboxView2') == 'false' || !localStorage.getItem('preferencesInboxView2')) ? false : true,
		},
		role: {}
	},
	getters: {
		isLoggedIn(state){
			return state.isLoggedIn
		},
		getJwt(state){
			return state.jwt
		},
		getUser(state){
			return JSON.parse(state.user)
		},
		getWorkspace(state){
			return JSON.parse(state.workspace)
		},
		getPreferences(state){
			return state.preferences
		},
		getRole(state){
			return state.role
		},
		getBrand(state){
			return state.brand
		},
		getWhiteLabel(state){
			return state.whiteLabel
		},
		getUserDb(state){
			return state.userDb
		}
	},
	mutations: {
		setJwt(state, jwt){
			state.jwt = jwt
		},
		setIsLoggedIn(state, jwt){
			state.isLoggedIn = (jwt && jwt.length) ? true : false
		},
		setUser(state, user){
			state.user = user
		},
		setWorkspace(state, workspace){
			state.workspace = workspace
		},
		setPreferences(state, preferences){
			state.preferences = preferences
		},
		setPreferencesNotifications(state, status){
			state.preferences.notifications = status
			localStorage.setItem('preferencesNotification', status);
		},
		setPreferencesInboxView2(state, status){
			state.preferences.inboxView2 = status
			localStorage.setItem('preferencesInboxView2', status);
		},
		setRole(state, role){
			state.role = role
		},
		setWhiteLabel(state, status){
			state.whiteLabel = status
		},
		setUserDb(state, data){
			state.userDb = data
		},
		setBrand(state, brand){
			brand.subdomain = _.filter(brand.domains, (d) => d.name === 'juphy.com' && d.records && d.records.length)
			brand.cname = _.filter(brand.domains, (d) => d.name !== 'juphy.com')
			state.brand = brand
		}
	},
	actions: {
		login({ commit }, data){
			localStorage.setItem('jwt', data.jwt);
			localStorage.setItem('user', JSON.stringify(data.user));
			commit('setJwt', localStorage.getItem('jwt'))
			commit('setUser', localStorage.getItem('user'))
		},
		setIsLoggedIn({ commit }){
			commit('setIsLoggedIn', localStorage.getItem('jwt'))
		},
		logout({ commit }){
			localStorage.setItem('jwt', '');
			commit('setJwt', localStorage.getItem('jwt'))
			commit('setIsLoggedIn', localStorage.getItem('jwt'))
		},
		setUser({ commit }, user){
			localStorage.setItem('user', JSON.stringify(user));
			commit('setUser', localStorage.getItem('user'))
		},
		setWorkspace({ commit }, workspace){
			localStorage.setItem('workspace', JSON.stringify(workspace));
			commit('setWorkspace', localStorage.getItem('workspace'))
		},
		setPreferences({ commit }, preferences){
			commit('setPreferences', preferences)
		},
		setPreferencesNotifications({ commit }, status){
			commit('setPreferencesNotifications', status)
		},
		setPreferencesInboxView2({ commit }, status){
			commit('setPreferencesInboxView2', status)
		},
		setRole({ commit }, role){
			commit('setRole', role)
		},
		setUserDb({ commit }, data){
			commit('setUserDb', data)
		},
		setWhiteLabel({ commit }, status){
			commit('setWhiteLabel', status)
		},
		setBrand({ commit }, brand){
			commit('setBrand', brand)
		}
	}
 };

 export default session;


// WEBPACK FOOTER //
// ./src/store/session.js